import React, { useEffect, useState } from 'react';
import { getAudiencia } from '../../service/apiBackEnd.js';
import { Container, Row, Col } from 'react-bootstrap';
import styles from '../index.module.css';

const Audiencia = () => {
  const [allData, setAllData] = useState([]);
  const [enrichedData, setEnrichedData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getAudiencia();
      console.log("DATA", res);
      setAllData(res);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const getMediaUrl = async (mediaId) => {
      try {
        const response = await fetch(`http://epas.test.di.dgi.loc/wp-json/wp/v2/media/${mediaId}`);
        const mediaData = await response.json();
        return mediaData.source_url;
      } catch (error) {
        console.error("Error fetching media:", error);
        return null;
      }
    };

    const fetchMediaUrls = async () => {
      const updatedData = await Promise.all(
        allData.map(async (elem) => {
          const archivoUrl = elem.acf?.adjuntar_archivo
            ? await getMediaUrl(elem.acf.adjuntar_archivo)
            : null;
          const archivoUrl2 = elem.acf?.adjuntar_archivo_2
            ? await getMediaUrl(elem.acf.adjuntar_archivo_2)
            : null;

          return { ...elem, archivoUrl, archivoUrl2 };
        })
      );
      setEnrichedData(updatedData);
    };

    if (allData.length > 0) {
      fetchMediaUrls();
    }
  }, [allData]);

  return (
    <Container>
      <Row>
        <h1 className="mt-5 mb-4">Audiencia Pública</h1>
        <Col>
          {enrichedData.map((elem) => {
            const textLugar = elem?.acf?.lugar ? elem.acf.lugar.replace(/<\/?[^>]+(>|$)/g, '') : '';
            return (
              <div className={styles.audiencia} key={elem.id}>
                {/* <Col lg={12}>
                  <h3>{elem.acf?.nombre}</h3>
                  <div className={styles.bgDetalle}>
                    <h6>
                      <b>Fecha y Hora: </b>
                      {elem.acf?.fecha} - {elem.acf?.hora}
                    </h6>
                    <h6>
                      <b>Lugar:</b> {textLugar}
                    </h6>
                  </div>
                  <hr />
                </Col>
                <Row className={styles.colData}>
                  <Col lg={6}>
                    <h5>
                      <b>Tema: {elem.acf?.tema}</b>
                    </h5>
                    <p>
                      <b>Contenido:</b> {elem.acf?.contenido}
                    </p>
                  </Col>
                  <Col lg={6}>
                    <li>
                      <b>Link Zoom: {elem.acf?.link_zoom}</b>
                    </li>
                    <li>
                      <b>Id reunión:</b> {elem.acf?.id_de_reunion}
                    </li>
                    <li>
                      <b>Código de acceso:</b> {elem.acf?.codigo_de_acceso}
                    </li>
                    <li>
                      <b>Instructor:</b> {elem.acf?.instructor}
                    </li>
                    <li className='mb-4'>
                      <b>Procedimiento:</b> {elem?.acf?.procedimiento}
                    </li>
                    {elem?.acf?.link_de_interes && (
                      <li>
                        <b>Link de interés:</b> {elem?.acf?.link_de_interes}
                      </li>
                    )}
                    {elem.archivoUrl && (
                      <a href={elem.archivoUrl} target="_blank" rel="noopener noreferrer" download className={styles.btnDescarga}>
                        Descargar Archivo 1
                      </a>
                    )}<br />
                    {elem.archivoUrl2 && (
                      <a href={elem.archivoUrl2} target="_blank" rel="noopener noreferrer" download className={styles.btnDescarga}>
                        Descargar Archivo 2
                      </a>
                    )}
                  </Col>
                </Row>
                <hr /> */}
              </div>
            );
          })}
        </Col>
      </Row>
    </Container>
  );
};

export default Audiencia;
